import http from './http';

export async function getPublicStoreSettings() {
  const { data } = await http.get('/api/settings/public');
  return data.settings;
}

export async function getAdminStoreSettings() {
  const { data } = await http.get('/api/settings');
  return data.settings;
}

export async function updateAdminStoreSettings(body) {
  const { data } = await http.put('/api/settings', body);
  return data.settings;
}
